import React from 'react'

import PropTypes from 'prop-types'

import {Grid, withStyles} from '@material-ui/core'
import ImportantButton from '../../../../shared/components/ImportantButton';

import styles from './styles'

/**
 * These are the buttons that are displayed at the bottom of the Offline Payment Feedback page.
 *
 * @param classes: {Object} containing the JSS classes for the current component to use.
 * @param printVoucher: {Function} invoked when the user pressed the Print button.
 * @param downloadVoucher: {Function} invoked when the user clicked the Download button.
 */
const VoucherButtons = ({classes, printVoucher, downloadVoucher}) => (
    <Grid container justify={"space-between"} className={classes.voucherButtonsContainer}>
        <Grid item xs={12} sm={"auto"}>
            <ImportantButton onClick={downloadVoucher} variant="outlined">
                Descargar
            </ImportantButton>
        </Grid>

        <Grid item xs={12} sm={"auto"}>
            <ImportantButton onClick={printVoucher}>
                Imprimir
            </ImportantButton>
        </Grid>
    </Grid>
)

VoucherButtons.propTypes = {
    downloadVoucher: PropTypes.func.isRequired,
    printVoucher: PropTypes.func.isRequired
}

const Styled = withStyles(styles)(VoucherButtons)

export default Styled
